import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function SpainJurisdiction() {

    return (
        <main className='main'>
            <SEO
                title="Spain Jurisdiction | Company Formation & Golden Visa"
                description="Set up companies and get residency in Spain. Golden Visa and Beckham Law tax benefits for investors, entrepreneurs, and expats."
                keywords="Spain company formation, Spain Golden Visa, Spain residency program, Beckham Law Spain, EU residency Spain, business setup Spain, tax residency Spain, investment Spain opportunities"
                url="/spain-jurisdiction"
            />
            <IntroSection
                title="Spain Jurisdiction"
                subtitle="Company Formation, Residency & Investment in Spain"
                description="Spain is one of the most attractive EU jurisdictions for investors, entrepreneurs, and families. It offers Golden Visa residency through real estate or business investment, a strategic European location, and favorable tax benefits such as the Beckham Law regime for expats."
                badges={[
                    "EU Residency",
                    "Company Formation",
                    "Golden Visa Program"
                ]}
                buttonText="Request a Spain Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/spain-jurisdiction.png')}
                imageAlt="Spain Company Formation & Residency"
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Spain?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Golden Visa Residency",
                                        text: "From €500,000 real estate investment."
                                    },
                                    {
                                        title: "EU Market Access",
                                        text: "Full European Union membership."
                                    },
                                    {
                                        title: "Tax Incentives",
                                        text: "Beckham Law offers reduced tax on foreign income."
                                    },
                                    {
                                        title: "Strong Property Market",
                                        text: "Demand in Madrid, Barcelona, Valencia, and coastal regions."
                                    },
                                    {
                                        title: "Lifestyle Benefits",
                                        text: "Mediterranean climate, world-class healthcare, and education."
                                    },
                                    {
                                        title: "Strategic Location",
                                        text: "Connecting Europe, Africa, and Latin America."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Company Formation in Spain"
                        blocks={[
                            {
                                title: "Types of Companies",
                                items: [
                                    { text: "Sociedad Limitada (SL / Private Limited Company) – most common." },
                                    { text: "Sociedad Anónima (SA / Public Limited Company) – for larger enterprises." },
                                    { text: "Branch of Foreign Company – for expanding international firms." },
                                    { text: "Self-Employed Entrepreneur (Autónomo) – for freelancers and sole traders." }
                                ]
                            },
                            {
                                title: "Key Features",
                                items: [
                                    { text: "Minimum share capital: €3,000 for SL, €60,000 for SA." },
                                    { text: "Incorporation Time: 2–3 weeks." },
                                    { text: "Corporate Tax Rate: 25% (15% for startups during the first two years)." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency & Citizenship in Spain"
                        blocks={[
                            {
                                title: "Spain Golden Visa",
                                items: [
                                    { text: "Minimum Investment: €500,000 in real estate." },
                                    { text: "Validity: 2 years (renewable for 5 years)." },
                                    { text: "Coverage: spouse + children + dependent parents." },
                                    { text: "Benefits: Free Schengen travel, right to live in Spain." },
                                    { text: "Citizenship Path: Eligible after 10 years of legal residence." }
                                ]
                            },
                            {
                                title: "Other Residency Options",
                                items: [
                                    { text: "Entrepreneur Visa – for innovative startups." },
                                    { text: "Non-Lucrative Visa – for retirees or those with passive income." },
                                    { text: "Digital Nomad Visa (2023) – remote workers can live in Spain while working abroad." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Spain Tax Incentives – The “Beckham Law”'
                        services={[
                            {
                                title: "Special Tax Regime",
                                text: "For expats moving to Spain."
                            },
                            {
                                title: "Flat 24% Tax",
                                text: "On Spanish income up to €600,000 for 6 years."
                            },
                            {
                                title: "Foreign Income",
                                text: "May be exempt."
                            },
                            {
                                title: "Attractive for High-Net-Worth Individuals",
                                text: "Entrepreneurs, executives, and professionals benefit."
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Advantages of Spain Jurisdiction'
                        features={[
                            {
                                title: "EU Residency & Market Access",
                                text: "Full access to the European Union market."
                            },
                            {
                                title: "Golden Visa",
                                text: "Acquire residency with €500k property investment."
                            },
                            {
                                title: "Growing Property Market",
                                text: "Opportunities in major cities and coastal regions."
                            },
                            {
                                title: "Flexible Company Formation Options",
                                text: "SL, SA, branches, and autónomo structures available."
                            },
                            {
                                title: "Tax Optimization",
                                text: "Beckham Law and double tax treaties."
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Want to invest or relocate to Spain?"
                        description="Offshore Advisory helps with Golden Visa applications, company formation, and tax planning under the Beckham Law."
                        buttonText="Book a Spain Consultation Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the minimum investment for Spain Golden Visa?",
        answer: "€500,000 in real estate."
    },
    {
        question: "How long to get Spanish citizenship?",
        answer: "10 years of legal residence (reduced to 2 years for Ibero-American nationals)."
    },
    {
        question: "Does Spain allow dual citizenship?",
        answer: "Generally no, but exceptions exist for Latin American and select countries."
    },
    {
        question: "How fast can I open a company in Spain?",
        answer: "2–3 weeks."
    },
    {
        question: "Is Spain good for remote workers?",
        answer: "Yes, the new Digital Nomad Visa makes Spain a top hub for expats."
    }
];

